export const EMPTY = 'null'
export const ON_HOLD = 'on-hold'
export const EXPIRED = 'expired'

export const weekDayNames = [
  null,
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  null
] as const
export const weekStartDay: 0 | 1 | 2 | 3 | 4 | 5 | 6 = 0
